export const START_COMMENT_KEYS = ['five', 'four', 'three', 'two', 'one'];

export const TAG_CATEGORY_KEYS = [
  'teachingStyle',
  'material',
  'topicDifficulty',
  'productUse',
  'other',
  'videoAudioQuality',
];

export const GET_TAG_CATEGORY = key => `common.tagCategory.${key}`;

export const MODAL_MODE = {
  FROM: 'FROM',
  THANKS_INFO: 'THANKS_INFO',
};
